import React, { useState } from 'react';
import { RefreshCw, Settings, SlidersHorizontal, X } from 'lucide-react';

// 辅导员分数评议页面
// 页面结构：条件筛选卡片 + 结果卡片（批量赋分/导出 + 学生评分表格）
export default function CounselorScoringPage() {
  // ================= 页面状态 =================
  const [isBatchScoreModalOpen, setIsBatchScoreModalOpen] = useState(false);
  const [editingStudent, setEditingStudent] = useState(null);

  // ================= 表格数据 =================
  const counselorScoreList = [
    {
      id: 1,
      batch: '第一批次',
      studentId: '2102001',
      name: '陈红',
      college: '计算机学院',
      className: '计科1班',
      teacherScore: '5',
      status: '已完成',
    },
    {
      id: 2,
      batch: '第一批次',
      studentId: '2102002',
      name: '林峰',
      college: '计算机学院',
      className: '计科2班',
      teacherScore: '-',
      status: '待完成',
    },
  ];

  return (
    <div className="animate-fade-in space-y-4">
      {/* 条件筛选卡片：按批次、学院、班级和学生信息查询 */}
      <div className="bg-white rounded shadow-sm border border-gray-100 p-5">
        <div className="grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 gap-x-8 gap-y-5">
          <FilterSelect label="批次" />
          <FilterSelect label="学院" />
          <FilterSelect label="班级" />
          <FilterSelect label="状态" />
          <FilterInput
            label="学号"
            placeholder="请输入学号"
          />
          <FilterInput
            label="姓名"
            placeholder="请输入姓名"
          />
        </div>

        {/* 查询按钮区 */}
        <div className="flex justify-end gap-3 mt-6">
          <button className="px-5 py-2 border border-gray-300 text-gray-700 rounded text-sm hover:bg-gray-50">
            重置
          </button>
          <button className="px-5 py-2 bg-[#1890ff] text-white rounded text-sm hover:bg-[#096dd9]">
            查询
          </button>
        </div>
      </div>

      {/* 结果卡片：辅导员评分列表 */}
      <div className="bg-white rounded shadow-sm border border-gray-100 p-5">
        {/* 表格上方操作按钮区 */}
        <div className="flex justify-between items-center mb-4">
          <div className="flex gap-3">
            <button
              onClick={() => setIsBatchScoreModalOpen(true)}
              className="px-5 py-2 bg-[#1890ff] text-white rounded text-sm hover:bg-[#096dd9]"
            >
              批量赋分
            </button>
            <button className="px-5 py-2 border border-gray-300 text-gray-700 rounded text-sm hover:bg-gray-50">
              导出
            </button>
          </div>

          <TableToolbar />
        </div>

        {/* 辅导员评分表格 */}
        <div className="overflow-x-auto border border-gray-200 rounded">
          <table className="w-full text-left border-collapse text-[13px] text-gray-700 whitespace-nowrap min-w-max">
            <thead>
              <tr className="bg-[#fafafa] border-b border-gray-200">
                <th className="py-3 px-4 w-10">
                  <input type="checkbox" className="rounded border-gray-300" />
                </th>
                <TableHead>序号</TableHead>
                <TableHead>批次</TableHead>
                <TableHead>学号</TableHead>
                <TableHead>姓名</TableHead>
                <TableHead>学院</TableHead>
                <TableHead>班级</TableHead>
                <TableHead>教师评价分(0-5)</TableHead>
                <TableHead>状态</TableHead>
                <th className="py-3 px-4 font-medium text-gray-800 sticky right-0 bg-[#fafafa] z-10 border-l border-gray-200">
                  操作
                </th>
              </tr>
            </thead>
            <tbody>
              {counselorScoreList.map((row, index) => (
                <tr
                  key={row.id}
                  className="border-b border-gray-100 hover:bg-[#f8f9fa] group"
                >
                  <td className="py-3 px-4">
                    <input type="checkbox" className="rounded border-gray-300" />
                  </td>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.batch}</TableCell>
                  <TableCell>{row.studentId}</TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.college}</TableCell>
                  <TableCell>{row.className}</TableCell>
                  <TableCell>
                    <span className="font-bold text-gray-900">
                      {row.teacherScore}
                    </span>
                  </TableCell>
                  <TableCell>
                    <span className={row.status === '已完成' ? 'text-green-600' : 'text-orange-500'}>
                      {row.status}
                    </span>
                  </TableCell>
                  <td className="py-3 px-4 sticky right-0 bg-white group-hover:bg-[#f8f9fa] z-10 border-l border-gray-100">
                    <button
                      onClick={() => setEditingStudent(row)}
                      className="text-[#1890ff] hover:underline"
                    >
                      修改
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 批量赋分弹窗：展示已选人数、总分提示和分数设置 */}
      {isBatchScoreModalOpen && (
        <BatchScoreModal
          selectedCount={counselorScoreList.length}
          totalScore={5}
          onClose={() => setIsBatchScoreModalOpen(false)}
        />
      )}

      {/* 右侧抽屉：修改辅导员分数评议 */}
      {editingStudent && (
        <CounselorScoreDrawer
          student={editingStudent}
          onClose={() => setEditingStudent(null)}
        />
      )}
    </div>
  );
}

// 辅导员分数评议修改抽屉
function CounselorScoreDrawer({ student, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-black/35">
      <div
        className="h-full bg-[#f3f6fa] shadow-[-8px_0_24px_rgba(0,0,0,0.18)] flex flex-col"
        style={{ width: 'min(760px, calc((100vw - 240px) * 0.5))' }}
      >
        {/* 抽屉标题栏 */}
        <div className="h-[58px] px-6 bg-white border-b border-gray-200 flex items-center justify-between">
          <h2 className="text-[16px] font-bold text-gray-900">
            修改辅导员分数评议
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X size={20} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-6 space-y-5">
          {/* 学生基本信息卡片 */}
          <div className="bg-white rounded shadow-sm border border-gray-100 p-5">
            <div className="grid grid-cols-2 gap-x-8 gap-y-4 text-sm">
              <InfoItem label="姓名" value={student.name} />
              <InfoItem label="学号" value={student.studentId} />
              <InfoItem label="批次" value={student.batch} />
              <InfoItem label="学院" value={student.college} />
              <InfoItem label="班级" value={student.className} />
              <InfoItem label="当前状态" value={student.status} />
            </div>
          </div>

          {/* 教师评价分修改卡片 */}
          <div className="bg-white rounded shadow-sm border border-gray-100 p-5">
            <div className="flex items-center gap-2 mb-5">
              <span className="w-1 h-4 bg-[#1890ff] rounded" />
              <h3 className="text-[15px] font-bold text-gray-900">
                教师评价分修改
              </h3>
            </div>

            {/* 总分提示信息 */}
            <div className="mb-5 px-3 py-3 bg-[#eaf4ff] border border-[#d3e8ff] rounded text-sm text-[#1677ff]">
              提示信息：教师评价分总分为 5 分，请输入 0-5 之间的整数。
            </div>

            <label className="flex items-center gap-3">
              <span className="w-[90px] text-sm text-gray-800 shrink-0">
                设置分数：
              </span>
              <input
                type="number"
                min="0"
                max="5"
                step="1"
                placeholder="请输入0-5之间的整数"
                onKeyDown={(event) => {
                  if (event.key === '.' || event.key === 'e' || event.key === '-') {
                    event.preventDefault();
                  }
                }}
                className="flex-1 border border-gray-300 rounded px-3 py-2 text-sm outline-none focus:border-[#1890ff]"
              />
            </label>
          </div>
        </div>

        {/* 抽屉底部按钮区 */}
        <div className="h-[64px] px-6 bg-white border-t border-gray-200 flex justify-end items-center gap-3">
          <button
            onClick={onClose}
            className="px-5 py-2 border border-gray-300 text-gray-700 rounded text-sm hover:bg-gray-50"
          >
            取消
          </button>
          <button
            onClick={onClose}
            className="px-5 py-2 bg-[#1890ff] text-white rounded text-sm hover:bg-[#096dd9]"
          >
            保存
          </button>
        </div>
      </div>
    </div>
  );
}

// 批量赋分弹窗
function BatchScoreModal({ selectedCount, totalScore, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/35">
      <div className="w-[460px] bg-white rounded shadow-[0_8px_28px_rgba(0,0,0,0.18)]">
        {/* 弹窗标题栏 */}
        <div className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
          <h3 className="text-[15px] font-bold text-gray-900">
            批量赋分
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X size={18} />
          </button>
        </div>

        {/* 弹窗提示信息 */}
        <div className="px-6 pt-5 space-y-3 text-sm text-gray-700">
          <div>
            当前已选择
            <span className="mx-1 font-bold text-[#1890ff]">
              {selectedCount}
            </span>
            人
          </div>
          <div className="px-3 py-3 bg-[#eaf4ff] border border-[#d3e8ff] rounded text-[#1677ff]">
            提示信息：总分是 {totalScore} 分。
          </div>
        </div>

        {/* 分数设置区 */}
        <div className="px-6 py-6">
          <label className="flex items-center gap-3">
            <span className="text-sm text-gray-800 shrink-0">
              设置分数：
            </span>
            <input
              type="number"
              min="0"
              max={totalScore}
              step="1"
              placeholder={`请输入0-${totalScore}之间的整数分`}
              onKeyDown={(event) => {
                if (event.key === '.' || event.key === 'e' || event.key === '-') {
                  event.preventDefault();
                }
              }}
              className="flex-1 border border-gray-300 rounded px-3 py-2 text-sm outline-none focus:border-[#1890ff]"
            />
          </label>
        </div>

        {/* 弹窗底部按钮区 */}
        <div className="px-5 py-4 border-t border-gray-100 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-5 py-2 border border-gray-300 text-gray-700 rounded text-sm hover:bg-gray-50"
          >
            取消
          </button>
          <button
            onClick={onClose}
            className="px-5 py-2 bg-[#1890ff] text-white rounded text-sm hover:bg-[#096dd9]"
          >
            确定赋分
          </button>
        </div>
      </div>
    </div>
  );
}

// 条件筛选：输入框
function FilterInput({ label, placeholder = '' }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-800 shrink-0 whitespace-nowrap">
        {label}：
      </span>
      <input
        placeholder={placeholder}
        className="border border-gray-300 rounded px-3 py-2 text-sm flex-1 min-w-0 outline-none focus:border-[#1890ff]"
      />
    </div>
  );
}

// 基本信息展示项
function InfoItem({ label, value }) {
  return (
    <div>
      <div className="text-gray-400 mb-1">
        {label}
      </div>
      <div className="text-gray-800">
        {value}
      </div>
    </div>
  );
}

// 条件筛选：下拉框
function FilterSelect({ label }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-800 shrink-0 whitespace-nowrap">
        {label}：
      </span>
      <select className="border border-gray-300 rounded px-3 py-2 text-sm flex-1 min-w-0 outline-none focus:border-[#1890ff] bg-white text-gray-500">
        <option>全部</option>
      </select>
    </div>
  );
}

// 表格工具按钮
function TableToolbar() {
  return (
    <div className="flex items-center gap-4 text-gray-700">
      <button className="hover:text-[#1890ff]" title="刷新">
        <RefreshCw size={18} />
      </button>
      <button className="hover:text-[#1890ff]" title="密度">
        <SlidersHorizontal size={18} />
      </button>
      <button className="hover:text-[#1890ff]" title="设置">
        <Settings size={18} />
      </button>
    </div>
  );
}

// 表格表头
function TableHead({ children }) {
  return (
    <th className="py-3 px-4 font-medium text-gray-800">
      {children}
    </th>
  );
}

// 表格单元格
function TableCell({ children }) {
  return (
    <td className="py-3 px-4">
      {children}
    </td>
  );
}
